var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinFeatured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 131,
    viewBox: "0 0 126 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4197_675)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4197_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.432 113C54.025 112.996 47.6824 111.749 41.771 109.329C35.8596 106.909 30.4968 103.365 25.993 98.9019C21.4892 94.439 17.9338 89.1457 15.5324 83.3282C13.131 77.5107 11.9315 71.2846 12.003 65.0101C12.1217 38.9884 34.0809 17.8888 60.927 18.0004C73.7277 18.1066 85.9661 23.1666 94.9721 32.0764C103.978 40.9862 109.021 53.0227 109 65.56C109.005 71.8018 107.75 77.983 105.31 83.749C102.869 89.5149 99.2896 94.752 94.777 99.1598C90.2645 103.567 84.9076 107.059 79.0138 109.434C73.1199 111.809 66.8052 113.021 60.432 113ZM17.608 65.489C17.624 76.5829 22.1146 87.2213 30.1021 95.0876C38.0895 102.954 48.9268 107.411 60.254 107.488C65.8865 107.526 71.4713 106.475 76.6883 104.395C81.9054 102.315 86.6523 99.2478 90.657 95.3685C94.6617 91.4892 97.8456 86.8742 100.026 81.7879C102.207 76.7016 103.342 71.2438 103.365 65.7274C103.392 60.1999 102.306 54.7216 100.168 49.606C98.0302 44.4903 94.8832 39.8379 90.9072 35.9149C86.9312 31.9919 82.2042 28.8755 76.9969 26.7441C71.7895 24.6126 66.204 23.5079 60.5602 23.4933C49.1869 23.512 38.2839 27.9403 30.235 35.8099C22.1861 43.6796 17.6462 54.3503 17.608 65.489Z",
    fill: "#F18181"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4197_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0645 31.0336C64.3165 30.7717 68.5184 32.0475 71.8667 34.6171C75.215 37.1867 77.4748 40.8698 78.214 44.9622C79.0413 49.4792 78.7804 54.1219 77.4521 58.5237C76.1238 62.9255 73.7644 66.9658 70.5602 70.3254C69.9513 71.036 69.5181 71.8738 69.2943 72.7738C69.228 72.9985 69.2103 73.234 69.2422 73.4657C69.2741 73.6974 69.3549 73.9201 69.4797 74.1197C69.6044 74.3193 69.7702 74.4915 69.9667 74.6254C70.1631 74.7593 70.386 74.8519 70.621 74.8975C73.1853 75.7562 75.7957 76.4779 78.4406 77.0594C80.5553 77.3189 82.5368 78.207 84.1161 79.6031C85.6954 80.9991 86.7958 82.8355 87.2678 84.8627C87.8615 86.9802 88.3653 89.1224 88.8831 91.2597C88.9951 91.6349 89.0271 92.0285 88.977 92.4163C88.927 92.804 88.796 93.1776 88.592 93.514C88.3881 93.8504 88.1155 94.1424 87.7913 94.372C87.4671 94.6016 87.0981 94.764 86.707 94.849C86.3319 94.9505 85.9396 94.9771 85.5537 94.9272C85.1678 94.8774 84.7962 94.752 84.4612 94.5586C84.1262 94.3653 83.8346 94.1079 83.6041 93.802C83.3735 93.4961 83.2087 93.148 83.1194 92.7784C82.4966 90.6214 81.9712 88.4372 81.418 86.2616C81.2146 85.3884 80.7435 84.5963 80.0674 83.9904C79.3913 83.3846 78.5422 82.9938 77.6329 82.87C74.4416 82.1637 71.294 81.2807 68.2056 80.2252C62.1938 78.0818 61.976 70.3057 65.513 66.9201C69.2134 63.4577 71.5779 58.8575 72.2084 53.894C72.5882 51.0073 73.0212 48.0725 72.1439 45.1573C71.4266 42.7909 69.9532 40.7096 67.9384 39.217C65.9237 37.7243 63.4729 36.8981 60.9431 36.8589C56.4275 36.7231 52.5791 37.8467 49.765 41.473C48.3748 43.2246 47.5752 45.3533 47.4762 47.5662C47.118 55.1065 49.1422 61.7912 54.7578 67.2362C57.877 70.2612 58.1505 78.1015 51.8006 80.2487C48.6675 81.3105 45.4318 82.1007 42.2176 82.9107C41.3781 83.0364 40.5949 83.4003 39.966 83.9571C39.337 84.5139 38.89 85.239 38.6807 86.0419C38.1405 88.1261 37.6009 90.2098 37.0616 92.2932C36.5552 94.244 35.0741 95.3095 33.4233 94.9206C32.9946 94.8305 32.5907 94.6519 32.2387 94.3968C31.8868 94.1416 31.5949 93.8159 31.3829 93.4416C31.1708 93.0672 31.0434 92.6529 31.0093 92.2265C30.9752 91.8 31.0352 91.3715 31.1852 90.9696C31.7168 88.7471 32.241 86.5073 32.917 84.3182C33.4446 82.473 34.5045 80.8143 35.9706 79.5396C37.4367 78.2648 39.2473 77.4276 41.1872 77.1274C43.8329 76.5532 46.4508 75.8198 49.0359 75.0037C51.1487 74.3357 51.5335 72.4355 49.9764 70.8502C46.4545 67.3749 43.9237 63.0632 42.6341 58.3414C41.3213 53.3693 40.7048 48.3095 42.1961 43.2781C43.3264 39.5733 45.7055 36.3488 48.9482 34.1267C52.191 31.9045 56.1077 30.8147 60.0645 31.0336Z",
    fill: "#F18181"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4197_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4682 6L93.0156 6.53366L99.4027 18.9857L113.089 20.9425L114.002 21.1203L113.637 21.8319L110.169 25.2117L108.709 26.4569L103.6 31.4377L104.147 35.1734L105.972 45.4908V45.8465L104.877 45.4908L100.68 43.3561L96.6653 41.2215L92.8331 39.2647L91.7382 39.6205L87.176 41.933L83.1613 44.0677L79.6941 45.8465H79.3291L79.6941 43.0004L81.7014 31.4377L76.4093 26.279L74.9494 25.0338L71.1172 21.2982V21.1203L85.8986 18.9857L88.271 14.3607L90.2783 10.2693L92.4682 6Z",
    fill: "#FBDB25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3047 21.3008L72.9471 21.6566L92.4732 27.8826L93.3856 28.772L95.5754 31.7961L97.9478 34.998L100.503 38.3779L102.875 41.5798L105.43 44.9597L105.612 45.4933H105.977V45.8491L104.882 45.4933L100.685 43.3587L96.6704 41.2241L92.8381 39.2673L91.7432 39.6231L87.181 41.9356L83.1663 44.0702L79.6991 45.8491H79.3341L79.6991 43.0029L81.7064 31.4403L76.4143 26.2816L74.9544 25.0364L71.3047 21.4787V21.3008Z",
    fill: "#F1BA18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4694 28.0586H92.8344L94.6592 30.549L99.4039 36.9529L101.959 40.3328L104.331 43.5347L105.608 45.1357V45.4915H105.973V45.8472L104.878 45.4915L100.681 43.3568L96.6666 41.2222L92.8344 39.2654L91.7394 39.6212L87.1773 41.9337L83.1626 44.0684L80.2428 45.4915L79.6953 45.3136L84.44 38.9097L86.9948 35.5298L91.7394 29.1259L92.4694 28.0586Z",
    fill: "#F1BA18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2847 28.0586V28.5923L85.1677 38.1981L82.6129 41.578L80.788 44.0684L79.8756 45.4915L79.6931 45.8472H79.3281L79.6931 43.001L81.7005 31.4384L82.2479 31.2605L92.2847 28.0586Z",
    fill: "#FBDB25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8359 27.8828L99.223 30.0174L102.69 31.0848L103.603 30.9069L104.333 30.3732L103.968 31.0848L103.603 31.4405L104.15 35.1762L105.793 44.4262V45.4936L105.063 44.782L102.69 41.5801L100.135 38.2002L93.0184 28.5944L92.8359 27.8828Z",
    fill: "#FCDC26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6484 6.35547L93.1959 6.88913L98.6705 17.5623L99.4005 19.1633L97.5756 21.4758L95.7507 23.9662L93.3784 27.1682L92.6484 27.8797V6.35547Z",
    fill: "#F1BA18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.085 21.4766H113.633L113.268 22.1881L110.165 25.2122L108.706 26.4574L104.508 30.5488L103.778 30.9045L103.413 31.2603L102.136 31.0824L93.1942 28.2362L93.0117 27.8805L107.428 23.2554L113.085 21.4766Z",
    fill: "#F1BA18"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4197_675",
    x: 0,
    y: 0,
    width: 126,
    height: 131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4197_675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4197_675",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4197_675",
    x: 12,
    y: 18,
    width: 97,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4197_675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4197_675",
    x: 27,
    y: 31,
    width: 66,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4197_675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4197_675",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4197_675",
    x: 67.1172,
    y: 6,
    width: 50.8828,
    height: 47.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4197_675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4197_675",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinFeatured);
export default __webpack_public_path__ + "static/media/SpinFeatured.ee1cc719b11e1a57cb67e827eca8c0d1.svg";
export { ForwardRef as ReactComponent };